/* import __COLOCATED_TEMPLATE__ from './pix-banner-alert.hbs.js'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
const TYPE_INFO = 'information';
const TYPE_ERROR = 'error';
const TYPE_WARNING = 'warning';
const TYPE_ENVIRONMENT = 'environment';
const TYPE_COMMUNICATION = 'communication';
const TYPE_COMMUNICATION_ORGA = 'communication-orga';
const TYPE_COMMUNICATION_CERTIF = 'communication-certif';
const types = [TYPE_INFO, TYPE_ERROR, TYPE_WARNING, TYPE_ENVIRONMENT, TYPE_COMMUNICATION, TYPE_COMMUNICATION_ORGA, TYPE_COMMUNICATION_CERTIF];
const icons = {
  [TYPE_INFO]: 'info',
  [TYPE_ERROR]: 'error',
  [TYPE_WARNING]: 'warning',
  [TYPE_ENVIRONMENT]: 'displaySettings',
  [TYPE_COMMUNICATION]: 'campaign',
  [TYPE_COMMUNICATION_ORGA]: 'campaign',
  [TYPE_COMMUNICATION_CERTIF]: 'campaign'
};
let PixBannerAlert = (_class = class PixBannerAlert extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "isBannerVisible", _descriptor, this);
  }
  get type() {
    return types.includes(this.args.type) ? this.args.type : TYPE_INFO;
  }
  get icon() {
    return icons[this.type];
  }
  get displayAction() {
    return this.args.actionLabel && this.args.actionUrl;
  }
  get isExternalLink() {
    return this.args.actionUrl.includes('/');
  }
  get canCloseBanner() {
    return this.args.canCloseBanner;
  }
  get displayBanner() {
    return this.isBannerVisible;
  }
  async closeBanner(params) {
    if (this.args.onCloseBannerTriggerAction) {
      await this.args.onCloseBannerTriggerAction(params);
    }
    this.isBannerVisible = false;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "isBannerVisible", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _applyDecoratedDescriptor(_class.prototype, "closeBanner", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeBanner"), _class.prototype), _class);
export { PixBannerAlert as default };